import React from 'react';
import './App.css';
import { Admin, Resource, resolveBrowserLocale } from 'react-admin';
import authProvider from './authProvider';
import MyLayout from './layout/MyLayout';
import SysMessages_EN from './i18n/en/SystemWord';
import SysMessages_JP from './i18n/jp/SystemWord';
import AppMessages_EN from './i18n/en/AppWord';
import AppMessages_JP from './i18n/jp/AppWord';
import MyDashboard from './components/dashboard/MyDashboard';
import Login from './components/login/Login';
import resources from './components/resources';
import operationRules from './components/operation-rules';
import users from './components/users';
import terminals from './components/terminals';
import createHistory from 'history/createBrowserHistory';
import customRoutes from './customRoutes';
import dataProvider from './dataProvider';
import reports from './components/reports';
import MyLogoutButton from './layout/MyLogoutButton';
import Role from './const/Role';

const messages = {
    en: { SysMessages_EN, ...AppMessages_EN },
    ja: { ...SysMessages_JP, ...AppMessages_JP }
};
const i18nProvider = locale => (messages[locale]) ? messages[locale] : messages["en"];
const history = createHistory();

const App = () => (
    <Admin
        dashboard={MyDashboard}
        authProvider={authProvider}
        dataProvider={dataProvider}
        appLayout={MyLayout}
        locale={resolveBrowserLocale()}
        i18nProvider={i18nProvider}
        loginPage={Login}
        history={history}
        customRoutes={customRoutes}
        logoutButton={MyLogoutButton}
        catchAll={Login}
    >
        {permissions => [
            (permissions & Role.OPERATION_MANAGER) === Role.OPERATION_MANAGER ? <Resource name="resources" {...resources} /> : null,
            (permissions & Role.OPERATION_MANAGER) === Role.OPERATION_MANAGER ? <Resource name="operation-rules" {...operationRules} /> : null,
            (permissions & Role.OPERATION_MANAGER) === Role.OPERATION_MANAGER ? <Resource name="terminals" {...terminals} /> : null,
            (permissions & Role.ACCOUNT_MANAGER) === Role.ACCOUNT_MANAGER ? <Resource name="users" {...users} /> : null,
            <Resource name="resource-groups" />,
            <Resource name="reports" {...reports} />
        ]}
    </Admin>
);

export default App;
